import axios from "axios";

const CURRENT_HASH = (import.meta as any).env.VITE_APP_GIT_SHA;

export default class VersionCheckHelper {
  static startPollingForVersion() {
    this.fetchLatestVersion("/version.json");
    setInterval(() => {
      this.fetchLatestVersion("/version.json");
    }, 30000);
  }

  static fetchLatestVersion(url: string) {
    // add timestamp to prevent caching
    axios.get(url + "?t=" + new Date().getTime()).then(response => {
      if (response?.data?.hash) {
        this.hasHashChanged(response.data.hash);
      }
    });
  }

  static hasHashChanged(latestHash: string) {
    if (CURRENT_HASH !== latestHash) {
      console.log("BUILD HASH CHANGED: Reloading...");
      window.location.reload();
    }
  }
}
